<template>
    <Breadcrumbs main="Ecommerce" title="Product" />
    <productHeader />
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const productHeader = defineAsyncComponent(() => import("@/components/theme/ecommerce/product/productHeader.vue"))
</script>